import React from 'react';
import { Heart, Shield, Users, TrendingDown } from 'lucide-react';

const WhySection = () => {
  const reasons = [
    {
      icon: Heart,
      title: 'Finanzielle Entlastung',
      description: 'Bestattungskosten können schnell mehrere tausend Euro betragen. Eine Sterbegeldversicherung schützt Ihre Angehörigen vor dieser finanziellen Belastung in einer ohnehin schweren Zeit.'
    },
    {
      icon: Shield,
      title: 'Selbstbestimmung',
      description: 'Legen Sie bereits zu Lebzeiten fest, wie Ihre Bestattung gestaltet werden soll. So können Sie sicher sein, dass Ihre Wünsche respektiert und umgesetzt werden.'
    },
    {
      icon: Users,
      title: 'Angehörige schützen',
      description: 'Ihre Liebsten müssen sich in der Trauerphase nicht mit finanziellen Sorgen belasten. Die Versicherungssumme wird schnell und unkompliziert ausgezahlt.'
    },
    {
      icon: TrendingDown,
      title: 'Planbare Beiträge',
      description: 'Mit überschaubaren monatlichen Beiträgen sichern Sie eine würdevolle Bestattung ab. Je früher Sie beginnen, desto günstiger sind die Beiträge.'
    }
  ];

  return (
    <section className="section section-light">
      <div className="container-custom">
        <div className="section-header fade-in">
          <p className="section-accent">✦ UNSERE EXPERTISE</p>
          <h2 className="headline-secondary">
            Warum Vorsorge sinnvoll ist
          </h2>
          <p className="subheadline">
            Eine Sterbegeldversicherung gibt Ihnen Sicherheit und entlastet Ihre Angehörigen 
            sowohl finanziell als auch organisatorisch in einer schweren Zeit.
          </p>
        </div>

        <div className="why-content-wrapper">
          <div className="why-image-container fade-in">
            <img 
              src="/couple-image.png"
              alt="Glückliches Paar - Gemeinsam vorsorgen für die Zukunft"
              loading="lazy"
              className="why-section-image"
            />
          </div>

          <div className="why-grid">
            {reasons.map((reason, index) => {
              const IconComponent = reason.icon;
              return (
                <div key={index} className="why-card fade-in" style={{ animationDelay: `${index * 0.1}s` }}>
                  <IconComponent className="icon-large" />
                  <h3>{reason.title}</h3>
                  <p>{reason.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySection;
